'use strict';

// leaflet
require("leaflet");
require("angular-leaflet-directive/dist/angular-leaflet-directive.js");

const MODULE_NAME = 'tael.module.observatoire';

var ngModule = angular.module(MODULE_NAME, [
    //require("../common/common-module"),
    'leaflet-directive' // OpenStreetMap
]);

// Warning : do NOT factorize this : webpack will not be able to parse parametrized context paths.
function requireAllInContext(context) {
    context.keys().forEach(context);
}
requireAllInContext(require.context("./ng", true, /\.(js|ts|less|css)$/));
requireAllInContext(require.context("./css", true, /\.(js|ts|less|css)$/));

module.exports = MODULE_NAME;


// WEBPACK FOOTER //
// ./src/modules/observatoire/observatoire-module.js